import { Injectable } from '@angular/core';
import { env } from '../environments/environment';
import { Router,CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { AuthService } from './services/auth.service';
import { HelperService } from './services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  token: any;

  constructor(private router: Router, private auth: AuthService, private helperService: HelperService) {
    
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.routeConfig.path === ':orderId') {
      let orderId = route.params.orderId;
      let email = route.queryParams.email;
      let key = route.queryParams.key;
      if (key && key === env.salesAppAuthKey) {
        this.setSession(key, email || 's.a@test.com');
      } else {
        if (!this.isAuthenticated()) {
          this.router.navigate(['account/login']);
          return false;
        }
      }
      return true;
    } else {
      if (!this.isAuthenticated()) {
        this.router.navigate(['account/login']);
        return false;
      }
      return true;
    }
  }

  setSession(key, email) {
    localStorage.setItem('token', key);
    localStorage.setItem('apiToken', key);
    localStorage.setItem('user', JSON.stringify({email: email, token: key}));
    localStorage.setItem('userId', email);
    const isTrialUser = 'TRUE';
    localStorage.setItem('isTrialUser', isTrialUser);
    this.auth.isLoggedIn();
    this.helperService.setIsTrial(true);
  }

  isAuthenticated(): boolean {
    try {
      let user: any = localStorage.getItem('user');
      user = JSON.parse(user);
      if (user && user.email) {
        return true;
      } else {
        return false;
      }
    } catch(err) {
      return false;
    }
  }
  
}
